import {Model} from 'vue-mc'
import {EventBus} from "../event-bus";

/**
 * Task model
 */
export class JobsModel extends Model {


    // Default attributes that define the "empty" state.
    defaults() {
        return {
            id: 0,
            interpreter_name: '',
            ref_num: 0,
            location: "",
            language: "",
            serviceDate: "",
            serviceTimeStart: "",
            serviceTimeEnd: "",
            CALD: "",
            requested_by: "",
            contact: "",
            statusUrl: "",
	        languages: {},
	        jobsByType: {},
	        jobsByStatus: {},
	        jobsByClockOnStatus: {},
	        jobsByLocation: {}
        }
    }

    constructor(attributes = {}, collection = null, options = {}) {
        super(attributes, collection, options);
        this.init();
    }


    options() {
        return {
            mutateBeforeSync: true
        }
    }

    init() {
        let self = this;
        EventBus.$on('activity-bus-message', (category, data) => {
            if (data != null && data.job_id != null) {
                self.updateStatus();
            }
        });
    }

    updateStatus() {
        if (this.ref_num === data.job_id.toString()) {
            let currentDate = new Date();
            this.early_clock_off = data.early_clock_off.toString();
            this.is_clocked_off = data.is_clocked_off.toString();
            this.is_late_sms_sent = data.is_late_sms_sent.toString();
            this.is_not_started = data.is_not_started.toString();
            this.is_late_clocked_on = data.is_late_clocked_on.toString();
            this.is_clocked_on = data.is_clocked_on.toString();
            this.on_break = data.on_break.toString();
            this.no_break = data.no_break.toString();

            if (this.is_clocked_off === "1") {
                this.activityStatus = "circleGreenOk clockOff"; // clock off
            } else if (this.serviceDate < currentDate) {
                this.activityStatus = "circleRed"; // old service date.
            } else if (this.is_clocked_on === "0") {
                this.activityStatus = "circleRed"; // not clocked on
                if (this.is_late_sms_sent === "1") {
                    this.activityStatus = "circleOrange"; // late sms
                } else if (this.is_not_started === "1" || this.is_late_clocked_on === "1") {
                    this.activityStatus = "circleAmber"; // not started or late clock on
                }
            } else {
                this.activityStatus = "circleGreen"; // clocked on
            }

            this.onBreakStatus = 'circleAmber';
        }
    }

    // Attribute mutations.
    mutations() {
        return {
            id: (id) => Number(id) || null,
            interpreter_name: String,
            ref_num: (ref_num) => Number(ref_num) || null
        }
    }

    // Attribute validation
    validation() {
        return {
            id: integer.and(min(1)).or(equal(null)),
            ref_num: integer.and(min(1)).or(equal(null))
        }
    }

    // Route configuration
    routes() {
        return {
            fetch: '/jobs/{id}'
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/jobsModel.js